"use client";

import { useEffect, useRef, useState } from "react";

export default function useSpeechRecognition() {
  const recognitionRef = useRef(null);
  const [listening, setListening] = useState(false);
  const [spokenText, setSpokenText] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!("webkitSpeechRecognition" in window)) {
      setError("Speech recognition not supported");
      return;
    }

    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = "en-GB";
    recognition.interimResults = false;
    recognition.continuous = false;

    recognition.onresult = (e) => {
      const text = e.results[0][0].transcript;
      setSpokenText(text.trim());
      setListening(false);
    };

    recognition.onerror = () => {
      setError("Speech recognition failed");
      setListening(false);
    };

    recognitionRef.current = recognition;
  }, []);

  const start = () => {
    setSpokenText("");
    setError(null);
    setListening(true);
    recognitionRef.current?.start();
  };

  const stop = () => {
    recognitionRef.current?.stop();
    setListening(false);
  };

  return {
    start,
    stop,
    listening,
    spokenText,
    error,
  };
}
